import { Phone, Loader2, Inbox, Gift } from "lucide-react";
import { Badge } from "../ui/badge";
import { fmtDate } from "./leadUtils";

const statusColors = {
  active: "bg-green-600/20 text-green-400 border-green-500/40",
  past_due: "bg-amber-600/20 text-amber-400 border-amber-500/40",
  canceled: "bg-zinc-600/20 text-zinc-400 border-zinc-500/40",
  pending: "bg-yellow-600/20 text-yellow-400 border-yellow-500/40",
};

export const MembersList = ({ members, loading }) => {
  if (loading) {
    return (
      <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin text-blue-500" /></div>
    );
  }
  if (members.length === 0) {
    return (
      <div data-testid="members-empty-state" className="text-center py-24 text-zinc-500">
        <Inbox className="h-12 w-12 mx-auto mb-4 text-zinc-700" />
        No members yet.
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="members-list">
      {members.map((m) => (
        <div
          key={m.membership_id}
          data-testid={`member-row-${m.membership_id}`}
          className="bg-[#121212] border border-zinc-800 rounded-xl p-4 sm:p-5 grid grid-cols-1 sm:grid-cols-12 gap-4 items-start sm:items-center"
        >
          <div className="sm:col-span-4">
            <div className="font-heading font-semibold text-white">{m.name || m.email}</div>
            <div className="text-zinc-500 text-xs">{m.email}</div>
            {m.phone && (
              <a
                href={`tel:${(m.phone || "").replace(/[^+\d]/g, "")}`}
                className="inline-flex items-center gap-1.5 text-blue-400 hover:text-blue-300 text-sm mt-0.5"
              >
                <Phone className="h-3.5 w-3.5" /> {m.phone}
              </a>
            )}
          </div>
          <div className="sm:col-span-3 text-sm">
            <div className="text-zinc-500 text-xs">Member Since</div>
            <div className="text-zinc-300">{fmtDate(m.enrolled_at)}</div>
          </div>
          <div className="sm:col-span-3 text-sm">
            <div className="text-zinc-500 text-xs">{m.cancel_at_period_end ? "Benefits End" : "Next Billing"}</div>
            <div className="text-zinc-300">{m.current_period_end ? fmtDate(m.current_period_end) : "—"}</div>
            <div className="text-zinc-600 text-xs mt-0.5 inline-flex items-center gap-1">
              <Gift className="h-3 w-3" /> {(m.complimentary_redemptions || []).length} redeemed
            </div>
          </div>
          <div className="sm:col-span-2 flex sm:justify-end">
            <Badge
              variant="outline"
              className={`${statusColors[m.status] || statusColors.pending} rounded-sm uppercase`}
              data-testid={`member-status-${m.membership_id}`}
            >
              {(m.status || "pending").replace("_", " ")}
            </Badge>
          </div>
        </div>
      ))}
    </div>
  );
};
